/**
 * Sri Lankan rupee.
 */
export var LKR = {
  code: 'LKR',
  base: 10,
  exponent: 2
};